import type { ExternalConnectionViewModel, NetworkViewModel } from '@trinnvis/dabih-api-client';

export function calculateConnectedViaNhn(c: ExternalConnectionViewModel, networks: NetworkViewModel[]) {
  const n = networks.find((network) => network.uuid === c.networkUuid);
  if (n === undefined) {
    return false;
  } else {
    return n.firewall === 'NHN' || n.firewall === 'NHNotherISP';
  }
}
